import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { ChapterLabel } from "./ChapterLabel";
import { featuredProjects, projects } from "../data/content";

const Chips = ({ items }) => (
  <div className="flex flex-wrap gap-2">
    {items.map((s) => (
      <span key={s} className="font-mono text-[11px] tracking-wide text-teal bg-teal-light px-2.5 py-1">
        {s}
      </span>
    ))}
  </div>
);

export default function Projects() {
  return (
    <section id="projects" className="section-shell" data-testid="projects-section">
      <div className="container-x">
        <ChapterLabel index="02" title="Projects" />

        {/* Featured work — larger tinted panels, click through to full case study */}
        <div className="grid md:grid-cols-2 gap-6 mb-6">
          {featuredProjects.map((p, i) => (
            <Reveal key={p.index} delay={i * 0.08}>
              <Link
                to={`/work/${p.slug}`}
                data-testid={`featured-project-${p.index}`}
                className="group bg-panelF border border-cardline p-8 sm:p-10 h-full flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_32px_-16px_rgba(28,28,28,0.18)]"
              >
                <div className="flex items-start justify-between mb-8">
                  <span className="font-mono text-xs tracking-[0.2em] text-faint">{p.index}</span>
                  <ArrowUpRight size={18} className="text-faint group-hover:text-teal group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all duration-300" />
                </div>
                <h3 className="font-display text-2xl sm:text-[1.7rem] font-semibold tracking-tight text-ink leading-snug">
                  {p.title}
                </h3>
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-teal mt-3">{p.context}</p>
                <p className="text-base text-body leading-relaxed mt-5">{p.description}</p>
                <p className="text-base text-ink leading-relaxed mt-4 pl-4 border-l-2 border-teal">{p.impact}</p>
                <div className="mt-8 pt-6 border-t border-cardline mt-auto flex items-end justify-between gap-4">
                  <Chips items={p.stack} />
                  <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-faint group-hover:text-teal transition-colors duration-300 shrink-0">
                    Case study →
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        {/* Remaining projects — compact structured cards */}
        <div className="grid sm:grid-cols-2 gap-px bg-hairline border border-hairline">
          {projects.map((p, i) => (
            <Reveal key={p.index} delay={i * 0.05} className="bg-canvas">
              <article
                data-testid={`project-card-${p.index}`}
                className="group p-7 sm:p-8 h-full flex flex-col transition-colors duration-300 hover:bg-panel"
              >
                <div className="flex items-baseline justify-between mb-5">
                  <span className="font-mono text-xs tracking-[0.2em] text-faint">{p.index}</span>
                  <ArrowUpRight size={15} className="text-faint group-hover:text-teal transition-colors duration-300" />
                </div>
                <h4 className="font-display text-xl font-semibold tracking-tight text-ink">{p.title}</h4>
                <p className="text-sm text-body leading-relaxed mt-3">{p.description}</p>
                <p className="text-sm text-ink mt-3 font-medium">{p.impact}</p>
                <div className="mt-6">
                  <Chips items={p.stack} />
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
